export default [
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'ID',
    },
    cell: {
      type: 'text',
      value: (e) => e.id,
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Type',
    },
    cell: {
      type: 'slot',
      name: 'type',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Give',
    },
    cell: {
      type: 'slot',
      name: 'give',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Get',
    },
    cell: {
      type: 'slot',
      name: 'get',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Rate',
    },
    cell: {
      type: 'slot',
      name: 'rate',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'ATM ID',
    },
    cell: {
      type: 'slot',
      name: 'atmId',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Status',
    },
    cell: {
      type: 'slot',
      name: 'status',
    },
  },
];
